import React from 'react'
import aImg from '../../images/about/1.png'

const About = (props) => {
    return (

        <section className="tf-about-section section-padding">
            <div className="container">
                <div className="tf-about-wrap">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12 col-12">
                            <div className="tf-about-img">
                                <img src={aImg} alt="" style={{ aspectRatio: "540 / 636", objectFit: "cover"}} />
                                <div className="tf-about-img-text">
                                    <div className="tf-about-icon">
                                        <h3>10+</h3>
                                        <span>Years Exprience</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-12">
                            <div className="tf-about-text">
                                <small>about Me</small>
                                <h2>Welcome to Yasser, Best Software Services</h2>
                                <h5>I have 10+ years of experiences in Software Development for give you better services.</h5>
                                <p>A dedicated senior software engineer with expertise in Node.js, Python, Ruby, React, React Native, Next.js, Vue.js, APIs,
                                testing, DevOps and more </p>
                                <p>Throughout my career, I have consistently demonstrated a strong ability to deliver high-quality software solutions that meet client needs and exceed expectations. My expertise spans across various domains, including web development, mobile app development, and cloud computing. I am passionate about staying up-to-date with the latest industry trends and technologies, ensuring that my skills remain relevant and cutting-edge.</p>
                                <p>In addition to my technical skills, I am also a strong communicator and team player. I enjoy collaborating with cross-functional teams to bring projects to fruition and am always eager to share my knowledge and mentor junior developers. My commitment to continuous learning and improvement drives me to seek out new challenges and opportunities for growth.</p>

                                <div className="tf-funfact">
                                    <div className="tf-funfact-item">
                                        <h3><span>100</span>+</h3>
                                        <p>Projects Completed</p>
                                    </div>
                                    {/* <div className="tf-funfact-item">
                                        <h3><span>52</span>+</h3>
                                        <p>Awards Win</p>
                                    </div> */}
                                    <div className="tf-funfact-item">
                                        <h3><span>70</span>+</h3>
                                        <p>Happy clients</p>
                                    </div>
                                    <div className="tf-funfact-item"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="visible-rotate-text">
                <h1>About Me</h1>
            </div>
        </section>
    )
}

export default About;